import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-layout',
  imports: [CommonModule],
  templateUrl: './layout-share.html',
  styleUrl: './layout.css',
})
export class LayoutComponent {
}

